module.exports = __webpack_public_path__ + "static/media/17.634ef57b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/17.png
// module id = 976
// module chunks = 0